import type { DosageUnit } from './constants';
import { formatDispenseAmount } from './formatDispenseAmount';
import { formatWithUnit } from './formatWithUnit';

/** A dispense amount with its unit as it reads on the pad, e.g. '42.9 g' or '8 capsules'; the amount alone without a unit. */
export const formatDispenseAmountWithUnit = (amount: number, unit?: DosageUnit) =>
  formatWithUnit(formatDispenseAmount(amount), unit);
